{
    "Vos communications": {
        "de": "Ihre Mitteilungen",
        "en": "Your communications"
    },
    "J’accepte de recevoir les nouveautés et offres du lieu par courriel.": {
        "de": "Ich möchte Neuigkeiten und Angebote des Veranstalters per E-Mail erhalten.",
        "en": "I agree to receive news and offers from the venue by email."
    },
    "Les billets, factures et informations nécessaires à vos commandes restent envoyés indépendamment de ce choix.": {
        "de": "Tickets, Rechnungen und notwendige Informationen zu Ihren Bestellungen erhalten Sie unabhängig von dieser Wahl.",
        "en": "Tickets, invoices and information needed for your orders are sent regardless of this choice."
    },
    "Enregistrer ma préférence": {
        "de": "Meine Auswahl speichern",
        "en": "Save my preference"
    },
    "Votre préférence est enregistrée.": {
        "de": "Ihre Auswahl wurde gespeichert.",
        "en": "Your preference has been saved."
    },
    "Se désinscrire des communications": {
        "de": "Mitteilungen abbestellen",
        "en": "Unsubscribe from communications"
    },
    "Confirmez le retrait des nouveautés et offres par courriel.": {
        "de": "Bestätigen Sie die Abmeldung von Neuigkeiten und Angeboten per E-Mail.",
        "en": "Confirm that you no longer wish to receive news and offers by email."
    },
    "Confirmer ma désinscription": {
        "de": "Meine Abmeldung bestätigen",
        "en": "Confirm my unsubscribe request"
    },
    "Votre demande est traitée si ce lien est encore valable. Les documents nécessaires à une commande restent disponibles.": {
        "de": "Ihre Anfrage wurde bearbeitet, sofern dieser Link noch gültig ist. Die für eine Bestellung erforderlichen Dokumente bleiben verfügbar.",
        "en": "Your request has been processed if this link is still valid. Documents needed for an order remain available."
    },
    "Ce lien de désinscription est incomplet. Ouvrez le lien reçu dans la communication.": {
        "de": "Dieser Abmeldelink ist unvollständig. Öffnen Sie den Link in der erhaltenen Mitteilung.",
        "en": "This unsubscribe link is incomplete. Open the link in the communication you received."
    },
    "Votre préférence a changé. Rechargez avant de confirmer.": {
        "de": "Ihre Auswahl wurde geändert. Laden Sie die Seite vor der Bestätigung neu.",
        "en": "Your preference has changed. Reload before confirming."
    }
}
